qw-location-list {
  max-width: 100%;
  border: solid 2px var(--qw-hotel-neutral-medium);
  background-color: #ffffff;
  border-radius: 5px;
  padding: 26px 30px;
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

qw-location-list .qw-location-list__item {
  font-size: 20px;
  font-family: var(--qw-hotel-font-family-b);
  margin: 0 0 24px;
  cursor: pointer;
}
qw-location-list .qw-location-list__item:last-of-type {
  margin: 0 0 0;
}

qw-location-list .qw-location-list__subtitle {
  display: none;
}

@media only screen and (max-width: 738px) {
  qw-location-list {
    width: 100%;
    padding: 14px 24px;
    border-radius: 0;
    border: 0;
    border-top: solid 2px var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
  }
  qw-location-list .qw-location-list__item {
    font-size: 21px;
    margin: 14px 0;
  }

  qw-location-list .qw-location-list__item:last-of-type {
    margin: 14px 0;
  }
}
